import React from 'react';
import { Image as ImageType } from '../../../types/api/ImageType';
import { Image, ImageModifier, ResponsiveType } from '../../../components/molecules/Image';
import { ImageContainer } from './ImageContainer';

function getInitialImageWithoutCaptionAndCopyright(initialImage: ImageType) {
  // @ts-expect-error -- we want to discard copyright and caption
  const { copyright: _1, caption: _2, ...currentImagePreview } = initialImage;
  return currentImagePreview as ImageType;
}
type PreviewImageProps = {
  image: ImageType | undefined;
  customAltText?: string;
  previewFilename?: string;
  lazyLoading?: boolean;
  responsiveType?: ResponsiveType;
  fetchUrl?: string;
};

export function ImagePreview({
  image,
  customAltText,
  responsiveType,
  fetchUrl,
  previewFilename,
  lazyLoading = false,
}: PreviewImageProps) {
  if (!image) {
    return null;
  }

  return (
    <ImageContainer filename={previewFilename}>
      <div className="image-upload__preview-image-container">
        <Image
          modifier={ImageModifier.WIDTH_AUTO}
          image={getInitialImageWithoutCaptionAndCopyright(image)}
          customAltText={customAltText}
          lazyLoading={lazyLoading}
          responsiveType={responsiveType}
          fetchUrl={fetchUrl}
        />
      </div>
    </ImageContainer>
  );
}
